import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const NotificationsInbox = React.lazy(() => import("./NotificationsInbox"));
const NotificationsLog = React.lazy(() => import("./NotificationsLog"));

/**
 * Notifications Module (2026-07-16) — the in-app channel's UI: the navbar bell
 * (src/components/NotificationBell.tsx, rendered in the shared navbar), the
 * per-person inbox, and the ADMIN-only tenant-wide log.
 *
 * Permissions resolve from the backend manifest
 * (business-builder-backend/src/modules/notifications/permissions.ts):
 * - self: any logged-in account reads its OWN inbox
 * - view: ADMIN — the full log exposes everyone's notification history
 */
const notificationsModuleConfig: ModuleConfig = {
    id: "notifications",
    name: "Notifications",
    description: "In-app notification inbox and tenant-wide notification log",
    version: "1.0.0",
    enabled: true,
    category: "communications",
    order: 40,
    icon: "🔔",
    color: "#4299E1",

    routes: [
        {
            path: "/notifications",
            component: NotificationsInbox,
            permissionLevel: "self",
            useLayout: true,
            layoutOptions: { maxW: "container.md" },
        },
        {
            path: "/notifications/log",
            component: NotificationsLog,
            permissionLevel: "view",
            useLayout: true,
        },
    ],

    navigation: [
        {
            label: "Notifications",
            path: "/notifications",
            icon: "🔔",
            permissionLevel: "self",
        },
        {
            label: "Notification Log",
            path: "/notifications/log",
            icon: "📜",
            permissionLevel: "view",
        },
    ],

    permissions: {
        view: [],
        create: [],
        edit: [],
        delete: [],
    },
};

export default notificationsModuleConfig;
